<template>
  <div class="relative">
    <div ref="threeArtboard" style="height: 100%;width: 100%;overflow: hidden;"></div>
    <div class="absolute bim-button-group flex">
      <div>
        <div class="bim-button" @click="threeBack()" v-if="!level">返回</div>
        <div class="bim-button" @click="openMenu(1)" v-if="!level">选择楼层</div>
        <div class="bim-button" @click="openMenu(3)" v-if="level">
          <img src="@/assets/img/back.svg" alt="" />
          当前楼层：楼层{{ level }}
        </div>
        <div class="bim-button" @click="openMenu(2)" v-if="level">点位标注</div>
        <div class="bim-button" @click="openMenu(1)" v-if="level">路线标注</div>
        <!-- 				<div class="bim-button" @click="cons({ geometryList, path3DList, spotList })" v-if="level">输出数据</div>
				<div class="bim-button" @click="sum" v-if="level">获取数据</div> -->
        <div class="bim-button" @click="reset">复位</div>
      </div>
      <div class="bim-button-group2" v-if="!level && isLevel">
        <div class="bim-button" @click="linkTo(5)">5f</div>
        <div class="bim-button" @click="linkTo(4)">4f</div>
        <div class="bim-button" @click="linkTo(3)">3f</div>
        <div class="bim-button" @click="linkTo(2)">2f</div>
        <div class="bim-button" @click="linkTo(1)">1f</div>
        <div class="bim-button" @click="linkTo(-1)">-1f</div>
      </div>
      <div class="bim-button-group2 relative" v-if="level && isLevel">
        <div class="bim-button" :class="index == line ? 'active' : ''" v-for="(item, index) in geometryList" @click="start(index)" :key="index">
          路线{{ index + 1 }}
          <span class="absolute line-delete" @click.stop="deleteLine(index)">×</span>
        </div>
        <div class="bim-button" @click="start(null)" v-if="geometryList.length < 6 && !isDraw">
          新增路线
        </div>
      </div>
      <div class="bim-button-group2" v-if="isSpot">
        <div class="spot">
          <div :class="spotType == 1 ? 'active' : ''" @click="addSpot(1)">
            <img src="@/assets/img/bim_img/IndoorFireHydrant.png" />
            <span>消火栓</span>
          </div>
          <div :class="spotType == 2 ? 'active' : ''" @click="addSpot(2)">
            <img src="@/assets/img/bim_img/SmokeSensation.png" />
            <span>烟感</span>
          </div>
          <div :class="spotType == 3 ? 'active' : ''" @click="addSpot(3)">
            <img src="@/assets/img/bim_img/FireExtinguisher.png" />
            <span>灭火器</span>
          </div>
          <div></div>
        </div>
      </div>
    </div>

    <div class="flex fixed" :style="'left:' + spotEditPosition.left + 'px;top:' + spotEditPosition.top + 'px;z-index:11111;background:#fff;border:1px solid #000'" v-if="isEdit">
      <div class="img-button flex" v-for="(item, index) in spotButtonList" v-if="isSpotEdit == item.isEdit || (!item.isEdit && item.val != 6)" :key="index">
        <img :src="item.url" @click="update(item.val)" :key="index" alt="" />
      </div>
    </div>
    <div class="fixed mask" v-if="isEdit"></div>
  </div>
</template>

<script>
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { LoadThree } from '../../mixin/LoadThreeMixin';
import { LoadOBJ } from '../../mixin/LoadOBJMixin';
import { getModel, spotTypeName } from '../../utils/bimUtils.js';
import * as THREE2 from 'three';
export default {
  name: 'three',
  props: {
    objModel: {
      type: Object,
      default: () => {
        return {
          // obj: '/bim/简化.obj',
          // mtl: '/bim/简化.mtl',
          obj: '/bim/haida.obj',
          // mtl: '/bim/简化.mtl',
          scale: [0.002, 0.002, 0.002],
          position: [0, 0, 0],
          rotation: [0, 2.2, 0],
          objType: 'admin',
          side: THREE.DoubleSide,
        };
      },
    },
  },
  mixins: [LoadThree, LoadOBJ],
  data() {
    return {
      path3DList: [], // 箭头数据
      geometryList: [], // 模型加载数据
      spotList: [],
      threeCustom: {
        // 箭头
        texture: '/bim/jiantou.png',
        color: [88, 222, 222],
        scrollUV: true,
        scrollSpeed: 0.03,
        width: 2,
        side: 'both',
        cornerRadius: 0.2,
        cornerSplit: 10,
        progress: 1,
        playSpeed: 0.14,
      },
      currentOBJ: '', // 当前建筑
      isSpot: false,
      isLevel: false, //二级菜单
      level: null, // 几层楼
      line: null, // 路线几
      spotType: null, // 点位类型
      spot: null, // 哪个点
      lastSpot: null,
      isDraw: false,
      drawing: false,
      playing: false,
      isSpotEdit: false, // 是否选择编辑
      isEdit: false, // 点位是否在编辑
      spotEditPosition: { left: 200, top: 200 },
      spotButtonList: [
        { url: require('@/assets/img/bim_img/left.svg'), val: '1', isEdit: true },
        { url: require('@/assets/img/bim_img/right.svg'), val: '2', isEdit: true },
        { url: require('@/assets/img/bim_img/little.svg'), val: '3', isEdit: true },
        { url: require('@/assets/img/bim_img/large.svg'), val: '4', isEdit: true },
        { url: require('@/assets/img/bim_img/ok.svg'), val: '5', isEdit: false },
        { url: require('@/assets/img/bim_img/edit.svg'), val: '6', isEdit: false },
        { url: require('@/assets/img/bim_img/delete.svg'), val: '7', isEdit: false },
      ],
    };
  },

  created() {},
  mounted() {
    this.loadBim();
    // 初始化箭头路径
    this.loadPath();
    // 平面几何
    const groundGeometry = new THREE.PlaneGeometry(500, 500);
    const groundMaterial = new THREE.MeshPhongMaterial({
      color: 0xcc8866,
    });
    const groundMesh = new THREE.Mesh(groundGeometry, groundMaterial);
    groundMesh.rotation.x = Math.PI * -0.5;
    this.scene.add(groundMesh);
    this.loadMTLOBJ(this.objModel, (obj) => {
      this.currentOBJ = obj;
    });
    // this.renderer.domElement.addEventListener('click', this.select);
  },
  methods: {
    // sum() {
    // 	// 开发用
    // 	this.getLine();
    // },
    // cons(val) {
    // 	// 开发用
    // 	console.log(val);
    // 	let arr = [];
    // 	if (this.path3DList[0])
    // 		this.path3DList[0]._points.forEach(item => {
    // 			arr.push(this.getArray(item));
    // 		});
    // 	console.log(arr);
    // },
    threeBack() {
      // console.log(111111111);
      this.isLevel = false;
      this.$emit('back', '');
      this.$router.back();
    },
    openMenu(val) {
      // 打开二级菜单
      this.spotType = null;
      if (val == 1) {
        this.isLevel = !this.isLevel;
        this.isSpot = false;
        this.addSpot(null);
      } else if (val == 2) {
        this.isLevel = false;
        this.isSpot = !this.isSpot;
        this.end();
      } else {
        this.isLevel = false;
        this.isSpot = false;
        this.level = null;
      }
    },
    start(val) {
      // 开始路线绘制,关闭点位绘制
      if (val || val == 0) {
        if (this.line == val) this.line = null;
        else this.line = val;
        this.drawing = true;
        this.loadPath();
        return;
      }
      this.line = null;
      this.geometryList.push(new THREE.PathGeometry());
      this.path3DList.push(new Path3D());
      this.loadPath();
      this.isDraw = true;
      this.drawing = true;
      this.playing = false;
      this.drawMessage = '左键绘制,右键停止,中键清除!';
      this.renderer.domElement.addEventListener('mousedown', this.onMouseDown);
      this.renderer.domElement.addEventListener('mousemove', this.onMouseMove);
      this.renderer.domElement.removeEventListener('click', this.spotMouseDown);
      // document.addEventListener('mousemove', this.mouseFllow);
    },

    end() {
      // 路线绘制结束
      this.isDraw = false;
      this.drawMessage = '';
      this.drawing = false;
      this.renderer.domElement.removeEventListener('mousedown', this.onMouseDown);
      this.renderer.domElement.removeEventListener('mousemove', this.onMouseMove);
      // document.removeEventListener('mousemove', this.mouseFllow);
    },
    move() {
      // 使箭头添加移动效果,暂时无用
      this.playing = true;
      this.drawing = false;
      this.threeCustom.progress = 0;
    },
    reset() {
      // 复位
      this.control.reset();
    },
    linkTo(e) {
      // 楼层跳转
      this.level = e;
      this.isLevel = false;
    },
    deleteLine(e) {
      // 删除路线
      if (!this.geometryList[e].pathId) {
        this.geometryList.splice(e, 1);
        this.path3DList.splice(e, 1);
        this.end();
        return;
      }
      this.$remove('/BimRoute/bimRoute/' + this.geometryList[e].pathId).then((res) => {
        if (res.code == 200) {
          this.geometryList.splice(e, 1);
          this.path3DList.splice(e, 1);
          this.loadPath();
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
        }
      });

      console.log();
    },
    getLine() {
      // 获取路线
      this.geometryList = [];
      this.path3DList = [];
      this.$get('/BimRoute/bimRoute/list', { layer: this.level }).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
          return;
        }
        let data = res.rows;
        data.forEach((item, index) => {
          this.geometryList.push(new THREE.PathGeometry());
          this.path3DList.push(new Path3D());
          this.path3DList[index].start();
          this.geometryList[index].pathId = item.id;
          this.geometryList[index].name = item.name;
          JSON.parse(item.data).forEach((it) => {
            this.path3DList[index].update(new THREE.Vector3(...it));
            this.path3DList[index].confirm();
          });
        });
        this.drawing = true;
        this.loadPath();
      });
    },
    loadSpot(e, data, object) {
      if (e < data.length) {
        data[e].position = JSON.parse(data[e].data);
        data[e].scale = JSON.parse(data[e].scale);
        data[e].rotation = JSON.parse(data[e].rotation);
        let objMesh = {
          ...spotTypeName[data[e].type],
          ...data[e],
          objType: 'spot',
          side: THREE.DoubleSide,
        };
        if (!object[+data[e].type]) {
          this.loadMTLOBJ(objMesh, (obj) => {
            this.spotList.push(obj);
            object[data[e].type] = obj;
            console.log(object[data[e].type], object);
            this.loadSpot(++e, data, object);
          });
        } else {
          let spot = object[data[e].type].clone();
          spot.position.set(...objMesh.position);
          spot.scale.set(...objMesh.scale);
          spot.rotation.set(...objMesh.rotation);
          spot.objType = 'spot';
          spot.objId = data[e].id;
          this.scene.add(spot);
          this.spotList.push(spot);
          this.loadSpot(++e, data, object);
        }
      }
    },
    getSpot() {
      this.spotList.forEach((item) => {
        this.scene.remove(item);
      });
      this.spotList = [];
      // 获取点位数据
      let object = [null, null, null, null];
      this.$get('/bim/bimDevice/list', { layer: this.level }).then((res) => {
        console.log(res.rows);
        let data = res.rows;
        this.loadSpot(0, data, object);
        // data.forEach(item => {
        // 	item.position = JSON.parse(item.data);
        // 	item.scale = JSON.parse(item.scale);
        // 	item.rotation = JSON.parse(item.rotation);
        // 	let objMesh = { ...spotTypeName[item.type], ...item, objType: 'spot', side: THREE.DoubleSide };
        // 	if (!object[item.type]) {
        // 		this.loadMTLOBJ(objMesh, obj => {
        // 			this.spotList.push(obj);
        // 			object[item.type] = obj;
        // 			console.log(object[item.type], object);
        // 		});
        // 	} else {
        // 		let spot = object[item.type].clone();
        // 		spot.position.set(...objMesh.position);
        // 		spot.scale.set(...objMesh.scale);
        // 		spot.rotation.set(...objMesh.rotation);
        // 		spot.objType = 'spot';
        // 		this.scene.add(spot);
        // 		this.spotList.push(spot);
        // 	}
        // });
        console.log(object);
      });
    },
    addSpot(e) {
      // 添加点位,看watch
      if (this.spotType != e) {
        this.spotType = e;
      } else {
        this.spotType = null;
      }
    },
    update(e) {
      // 添加时按钮功能
      console.log(e, this.spot);
      switch (+e) {
        case 1: // 左
          this.spot.rotation.y -= 0.1;
          break;
        case 2: // 右
          this.spot.rotation.y += 0.1;
          break;
        case 3: // 小
          this.spot.scale.x -= 0.01;
          this.spot.scale.y -= 0.01;
          this.spot.scale.z -= 0.01;
          break;
        case 4: // 大
          this.spot.scale.x += 0.01;
          this.spot.scale.y += 0.01;
          this.spot.scale.z += 0.01;
          break;
        case 5: // ok
          this.isEdit = false;
          this.isSpotEdit = false;
          let data = {
            scale: JSON.stringify(this.getArray(this.spot.scale)),
            data: JSON.stringify(this.getArray(this.spot.position)),
            rotation: JSON.stringify(this.getArray(this.spot.rotation)),
            type: this.spotType || (this.spot.name == '消防栓' ? 1 : this.spot.name == '烟感' ? 2 : 3),
            layer: this.level,
          };
          console.log(this.spot);
          if (this.spot.objId)
            this.$put('/bim/bimDevice', { ...data, id: this.spot.objId }).then((res) => {
              // this.spot.objId = res.data;
            });
          else
            this.$post('/bim/bimDevice', data).then((res) => {
              this.spot.objId = res.data;
              this.addSpot(this.spotType);
            });
          break;
        case 6: // 编辑
          this.isSpotEdit = true;
          break;
        case 7: // 删除
          this.isEdit = false;
          this.isSpotEdit = false;
          console.log(this.spot.objId);
          if (this.spot.objId) {
            this.$remove('/bim/bimDevice/' + this.spot.objId).then((res) => {
              this.scene.remove(this.spot);
              this.spot = null;
            });
          } else this.scene.remove(this.spot);
          break;
        default:
          break;
      }
    },
    deleteSpot(e) {
      // 删除点位
    },
    selectSpot(e) {
      // 查询点位,watch触发

      let intersects = this.getMouseBim(this.scene.children);
      this.spot = intersects.find((item) => {
        return item.object.objType == 'spot' || item.object.parent.objType == 'spot';
      });
      console.log(11111111, this.scene, this.spot);
      if (this.spot && this.spot.object.objType != 'spot') this.spot = this.spot.object.parent;
      if (this.spot) {
        this.isEdit = true;
        this.spotEditPosition.left = e.x + 50;
        this.spotEditPosition.top = e.y;
      }
    },
    spotMouseDown(e) {
      // 添加点位鼠标点击
      let intersects = this.getMouseBim(this.scene.children);

      let localObj = intersects.filter((item) => {
        return item.object.objType != 'spot' && item.object.parent.objType != 'spot';
      });

      let objMesh = {
        ...spotTypeName[this.spotType],
        scale: [0.2, 0.2, 0.2],
        position: this.getArray(localObj[0].point),
        rotation: [0, 0, 0],
        objType: 'spot',
        side: THREE.DoubleSide,
      };
      if (this.spotType == 2 && objMesh.position[1] < 5) {
        objMesh.position[1] = 10;
      }
      if (this.lastSpot?.type == this.spotType) {
        let spot = this.lastSpot.obj.clone();
        spot.position.set(...objMesh.position);
        spot.objType = 'spot';
        this.spot = spot;
        this.scene.add(spot);
        this.spotList.push(spot);
        this.isEdit = true;
      } else
        this.loadMTLOBJ(objMesh, (obj) => {
          console.log(this.spot);
          this.spotList.push(obj);
          obj.objId = null;
          this.spot = obj;
          this.lastSpot = { obj: this.spot, type: this.spotType };
          this.isEdit = true;
        });
      console.log(e);
      this.spotEditPosition.left = e.x + 50;
      this.spotEditPosition.top = e.y;
      // console.log(spotTypeName[this.spotType]);
    },
    spotMouseMove(e) {
      // 暂无用
      let intersects = this.getMouseBim(this.scene.children);
      let localObj = intersects.filter((item) => {
        return item.object.name != 'spot';
      });
    },
    onMouseDown() {
      // 路线绘制鼠标点击
      if (event.button == 0) {
        if (!this.drawing) {
          return;
        }
        let intersects = this.getMouseBim(this.scene.children);
        if (intersects.length > 0) {
          this.path3DList[this.path3DList.length - 1].confirm();
        }
      } else if (event.button == 1) {
        this.path3DList[this.path3DList.length - 1].clear();
        this.geometryList[this.geometryList.length - 1].update(this.path3DList[this.path3DList.length - 1].getPathPointList());
        this.path3DList.splice(this.path3DList.length - 1, 1);
        this.geometryList.splice(this.path3DList.length - 1, 1);
        this.drawing = false;
        this.end();
      } else if (event.button == 2) {
        this.drawing = false;
        this.end();
        this.path3DList[this.path3DList.length - 1].stop();
        this.geometryList[this.geometryList.length - 1].update(this.path3DList[this.path3DList.length - 1].getPathPointList(), {
          width: this.threeCustom.width,
          side: this.threeCustom.side,
          arrow: true,
        });
        if (this.path3DList[this.path3DList.length - 1]._points.length < 2) {
          this.path3DList[this.path3DList.length - 1].clear();
          this.path3DList.splice(this.path3DList.length - 1, 1);
          this.geometryList.splice(this.geometryList.length - 1, 1);
        } else {
          let arr = [];
          this.path3DList[this.path3DList.length - 1]._points.forEach((item) => {
            arr.push(this.getArray(item));
          });
          let data = JSON.stringify(arr);
          this.$post('/BimRoute/bimRoute', { layer: this.level, data }).then((res) => {
            console.log(res);
            this.geometryList[this.geometryList.length - 1].pathId = res.data;
          });
        }
      }
    },
    onMouseMove(event) {
      // 路线绘制鼠标移动
      if (!this.drawing) {
        return;
      }
      let intersects = this.getMouseBim(this.scene.children);
      if (intersects.length > 0) {
        if (this.path3DList[this.path3DList.length - 1]._drawing == false) this.path3DList[this.path3DList.length - 1].start();
        this.path3DList[this.path3DList.length - 1].update(intersects[0].point);
      }
    },
    loadBim() {
      // 加载bim、three模型
      this.geometryList.forEach((item, index) => {
        console.log(!(this.line || this.line == 0) || this.line == index);
      });

      this.loadThree(this.$refs.threeArtboard, () => {
        if (this.path3DList.length > 0) {
          this.drawPathTexture.offset.x -= 0.06; // 使箭头动起来
        }
        this.renderer.domElement.style.cursor = this.isDraw ? 'crosshair' : 'default';
        if (this.drawing && this.path3DList.length > 0) {
          this.geometryList.forEach((item, index) => {
            item.update(this.path3DList[index].getPathPointList(), {
              //时时绘制
              width: this.threeCustom.width,
              side: this.threeCustom.side,
              arrow: true,
            });
          });
        } else {
          if (this.playing) {
            // 实现剪头运动
            let pathPointList = this.path3D.getPathPointList();
            let distance = pathPointList.distance();
            if (distance > 0) {
              this.threeCustom.progress += this.threeCustom.playSpeed / distance;
              if (this.threeCustom.progress >= 1) {
                this.threeCustom.progress = 1;
                this.playing = false;
              }
            } else {
              this.threeCustom.progress = 1;
              this.playing = false;
            }
            this.geometry.update(pathPointList, {
              width: this.threeCustom.width,
              side: this.threeCustom.side,
              progress: this.threeCustom.progress,
              arrow: true,
            });
          }
        }
      });
    },
    loadPath() {
      // 加载路线
      this.scene.remove(
        this.scene.children.find((item) => {
          return item.name == 'path';
        }),
      );
      // 初始化箭头材质
      this.drawPathTexture = new THREE.TextureLoader().load(this.threeCustom.texture, (texture) => {
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
      });
      let material = new THREE2.MeshPhongMaterial({
        color: 0xffffff,
        depthWrite: true,
        transparent: true,
        opacity: 1,
        side: THREE.DoubleSide,
        map: this.drawPathTexture,
      });
      let group = new THREE.Group();
      this.geometryList.forEach((item, index) => {
        let mesh;
        if (!(this.line || this.line == 0) || this.line == index) mesh = new THREE.Mesh(item, material);
        group.add(mesh);
      });
      group.name = 'path';
      this.scene.add(group);
    },
    getMouseBim(obj) {
      // 鼠标点击获取模型 ,重复代码提取
      let raycaster = new THREE2.Raycaster();
      let mouse = {
        x: '',
        y: '',
      };
      //全屏无偏移
      // mouse.x = (event.clientX / this.renderer.domElement.clientWidth) * 2 - 1.01;
      // mouse.y = -(event.clientY / this.renderer.domElement.clientHeight) * 2 + 1.08;
      mouse.x = ((event.clientX - this.renderer.domElement.getBoundingClientRect().left) / this.renderer.domElement.clientWidth) * 2 - 1.0;
      mouse.y = -((event.clientY - this.renderer.domElement.getBoundingClientRect().top) / this.renderer.domElement.clientHeight) * 2 + 1.0;
      raycaster.setFromCamera(mouse, this.camera);
      return raycaster.intersectObjects(obj);
    },
    getPosition(pos = {}) {
      // 根据three三维点位转化为plus.push.二维点位
      let a = new THREE.Vector3(pos.x, pos.y, pos.z);
      let vector = a.project(thiscamera);
      let halfWidth = this.renderer.domElement.clientWidth / 2;
      let halfHeight = this.renderer.domElement.clientHeight / 2;
      let result = {
        x: Math.round(vector.x * halfWidth + halfWidth),
        y: Math.round(-vector.y * halfHeight + halfHeight),
      };
      return result;
    },
    getArray(val) {
      // 将three三维点位转化为数组
      return [val.x, val.y, val.z];
    },
  },
  watch: {
    level(val) {
      this.scene.remove(this.currentOBJ);
      getModel(this.objModel, val);
      this.loadMTLOBJ(this.objModel, (obj) => {
        this.currentOBJ = obj;
        this.getLine();
        this.getSpot();
      });
    },
    spotType(val) {
      if (val) {
        this.renderer.domElement.addEventListener('click', this.spotMouseDown);
        this.renderer.domElement.addEventListener('mousemove', this.spotMouseMove);
      } else {
        this.renderer.domElement.removeEventListener('click', this.spotMouseDown);
        this.renderer.domElement.removeEventListener('mousemove', this.spotMouseMove);
      }
    },
    isSpot(val) {
      if (val == true && !this.spotType) {
        this.renderer.domElement.addEventListener('click', this.selectSpot);
      } else {
        this.renderer.domElement.removeEventListener('click', this.selectSpot);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.fixed {
  position: fixed;
}
.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.bim-button-group {
  top: 12px;
  left: 12px;
}
.bim-button {
  font-size: 12px;
  padding: 8px 12px;
  margin-bottom: 12px;
  background-color: #169bd5;
  color: #ffffff;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.bim-button-group2 {
  .active {
    border: 1px solid #000000;
  }
  .bim-button {
    /* margin-left: 12px; */
    font-size: 12px;
    transform: scale(0.8);
    margin-bottom: 8px;
    width: 80px;
    padding: 4px 12px;
  }
}
.spot {
  display: grid;
  grid-template-columns: 60px 60px;
  grid-auto-rows: 83px;
  text-align: center;
  background-color: #000;
  margin-left: 12px;
  grid-gap: 1px;
  padding: 1px;
  div {
    background-color: #ffffff;
    display: grid;
    align-items: center;
    cursor: pointer;
  }
  .active {
    background-color: #bcbcbc;
  }
}
.line-delete {
  right: 6px;
  padding: 0 3px;
  // color: #ff0000;
}
.img-button {
  height: 32px;
  width: 32px;
  padding: 2px;
  border-right: 1px solid #000;
}
.img-button:last-child {
  border-right: none;
}
</style>
